import { StyleSheet } from 'aphrodite';

const styles = StyleSheet.create({
    buttonStyle: {
        backgroundColor: '#C01236',
        padding: '8px 20px',
        color: 'white',
        textTransform: 'uppercase',
        border: 'none',
        cursor: 'pointer',
        transition: 'ease 0.3s',

        ':hover': {
          backgroundColor: '#880b25'
        }
    },
    buttonText: {
      lineHeight: '26px',
      verticalAlign: 'bottom'
    },
    buttonImage: {
      marginLeft: '16px'
    }
});

export default styles;
